export default "__VITE_ASSET__4dfa2233__"